import React, { useEffect } from "react";
import AppMyAccountCard from "@/features/my-account/app-my-account-card";
import { Box, Button, Flex, Switch, Text } from "@chakra-ui/react";
import SVG from "react-inlinesvg";
import MyPageEditButton from "@/features/my-account/my-page-edit-button";
import FavoriteBrandModal from "@/features/dashboard/features/favorite-brand-section/components/favorite-brand-modal";
import FavoriteProductEditModal from "@/features/my-account/favorite-product-edit-modal";
import useIdentity from "@/features/ui/hooks/use-identity";
import apiClient from "@/features/dashboard/api/axios";
import axiosClient, { getAuthTokenFromCookies } from "@/utils/axios-client";
import useGetUserInfo from "@/features/my-account/hooks/useGetUserInfo";
import useUpdateUserInfo from "@/features/my-account/hooks/useUpdateUserInfo";
import FavoriteProductEditModalWrapper from "@/features/my-account/favorite-product-edit-modal-wrapper";
import useAppToasts from "@/features/line-sheet-sets/hooks/use-app-toasts";

function AlertCard() {
  const [isOpen, setIsOpen] = React.useState(false);
  const [isProductEditOpen, setIsProductEditOpen] = React.useState(false);
  const identity = useIdentity();
  const { userInfo } = useGetUserInfo(identity?.id);
  const { mutateUserInfo } = useUpdateUserInfo(identity?.id);
  const { info } = useAppToasts();
  const currentDate = new Date();
  const formattedCurrentDate = `${currentDate.getFullYear()}년 ${
    currentDate.getMonth() + 1
  }월 ${currentDate.getDate()}일`;

  return (
    <AppMyAccountCard
      title={
        <Flex color={"#8F8F8C"} gap={"8px"}>
          <SVG src={"/icons-v1_1/bell.svg"} width={20} height={20} />
          <Text textStyle={"body-lg-bold"} color={"#444444"}>
            알림 설정
          </Text>
        </Flex>
      }
    >
      <Flex flexDirection={"column"} gap={"24px"}>
        <Flex flexDirection={"column"} gap={"16px"}>
          <Text textStyle={"body-md-bold"}>관심 정보</Text>
          {/* 설명이 길어 좁은 폭에서 줄바꿈된다. 텍스트 쪽에 minWidth 0이 없으면 축소되지
              않아 컨트롤을 밀어내고, 컨트롤에 flexShrink 0이 없으면 스위치가 눌린다. */}
          <Flex
            justifyContent={"space-between"}
            alignItems={"center"}
            gap={"12px"}
          >
            <Flex flexDirection={"column"} gap={"4px"} minWidth={0}>
              <Text textStyle={"body-sm-bold"}>관심 브랜드 알림</Text>
              <Text textStyle={"body-sm-regular"}>
                관심으로 설정한 브랜드의 라인시트가 발행되면 알림을 받을 수
                있습니다.
              </Text>
            </Flex>
            <Flex flexShrink={0}>
              <MyPageEditButton onClick={() => setIsOpen(true)} />
              <Switch
                isChecked={!!userInfo?.agree_to_receive_favorite_brand_alert}
                onChange={() => {
                  mutateUserInfo({
                    agree_to_receive_favorite_brand_alert:
                      !userInfo?.agree_to_receive_favorite_brand_alert,
                  });
                  info(
                    userInfo?.agree_to_receive_favorite_brand_alert
                      ? `관심 브랜드 알림을 수신거부하였습니다. (거부 일자 : ${formattedCurrentDate})`
                      : `관심 브랜드 알림을 수신동의하였습니다. (동의 일자 : ${formattedCurrentDate})`
                  );
                }}
              />
            </Flex>
          </Flex>
          <Flex
            justifyContent={"space-between"}
            alignItems={"center"}
            gap={"12px"}
          >
            <Flex flexDirection={"column"} gap={"4px"} minWidth={0}>
              <Text textStyle={"body-sm-bold"}>관심 상품 알림</Text>
              <Text textStyle={"body-sm-regular"}>
                관심으로 설정한 상품이 포함된 라인시트가 발행되면 알림을 받을 수
                있습니다.
              </Text>
            </Flex>
            <Flex flexShrink={0}>
              <MyPageEditButton onClick={() => setIsProductEditOpen(true)} />
              <Switch
                isChecked={!!userInfo?.agree_to_receive_favorite_sku_alert}
                onChange={() => {
                  mutateUserInfo({
                    agree_to_receive_favorite_sku_alert:
                      !userInfo?.agree_to_receive_favorite_sku_alert,
                  });
                  info(
                    userInfo?.agree_to_receive_favorite_sku_alert
                      ? `관심 상품 알림을 수신거부하였습니다. (거부 일자 : ${formattedCurrentDate})`
                      : `관심 상품 알림을 수신동의하였습니다. (동의 일자 : ${formattedCurrentDate})`
                  );
                }}
              />
            </Flex>
          </Flex>
        </Flex>
        <hr />
        <Flex flexDirection={"column"} gap={"16px"}>
          <Text textStyle={"body-md-bold"}>혜택/마케팅</Text>
          <Flex
            justifyContent={"space-between"}
            alignItems={"center"}
            gap={"12px"}
          >
            <Flex flexDirection={"column"} gap={"4px"} minWidth={0}>
              <Text textStyle={"body-sm-bold"}>마케팅 알림</Text>
              <Text textStyle={"body-sm-regular"}>
                이벤트, 혜택, 추천 상품 등 상품 소싱에 도움이 되는 알림을 받을
                수 있습니다.
              </Text>
            </Flex>
            <Switch
              flexShrink={0}
              isChecked={!!userInfo?.agree_to_marketing}
              onChange={() => {
                mutateUserInfo({
                  agree_to_marketing: !userInfo?.agree_to_marketing,
                });
                info(
                  userInfo?.agree_to_marketing
                    ? `마케팅 알림을 수신거부하였습니다. (거부 일자 : ${formattedCurrentDate})`
                    : `마케팅 알림을 수신동의하였습니다. (동의 일자 : ${formattedCurrentDate})`
                );
              }}
            />
          </Flex>
        </Flex>
        <FavoriteProductEditModalWrapper
          isProductEditOpen={isProductEditOpen}
          setIsProductEditOpen={setIsProductEditOpen}
        />
        <FavoriteBrandModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
      </Flex>
    </AppMyAccountCard>
  );
}

export default AlertCard;
